import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import extended from '../extend-language-detector.js';
import options from '../i18next-options.js';

/**
 * An i18next wrapper with built-in language detection and mapping for IBM Cloud Console applications.
 * 
 * @author Nick Chevsky <nchevsky@ibm.com>
 * 
 * @see https://github.ibm.com/ibmcloud/console-i18n
 * @see https://www.i18next.com/
 */
const index = i18next.createInstance({
  ...options,
  detection: {
    order: ['querystring', 'navigator']
  }
}).use(extended(LanguageDetector));

export { index as default };
